import Vue from 'vue'

export default {
    settlementsList(params) {
        return Vue.axios.get(`/np/settlements?from_admin=true`, {params})
    },
    settlementToggleEnabled(id) {
        return Vue.axios.get(`/np/settlements/${id}`)
    },
    show(id) {
        return Vue.axios.get(`/np/settlements/show/${id}?from_admin=true`)
    },
    update(id, params) {
        return Vue.axios.post(`/np/settlements/update/${id}?from_admin=true`, {params})
    },
}
